import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Home Assistant local")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("URL: ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("http://YOUR_LOCAL_ADDRESS:8123/ [Get exact address from your administrator or read ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("our wiki guide")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("]")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Login: ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("your Parachain Address added in subscription")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Password: ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("use password created here")

export function render(_ctx, _cache) {
  const _component_robo_card_title = _resolveComponent("robo-card-title")
  const _component_robo_section = _resolveComponent("robo-section")
  const _component_robo_text = _resolveComponent("robo-text")
  const _component_robo_link = _resolveComponent("robo-link")

  return (_openBlock(), _createBlock(_component_robo_section, null, {
    default: _withCtx(() => [
      _createVNode(_component_robo_section, {
        backColor: "rgb(16, 202, 249)",
        backImage: "images/ha-logo.png",
        backSize: "contain",
        textColor: "#ffffff",
        offset: "x0",
        backPosition: "100% 10%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_robo_card_title, {
            size: "2",
            offset: "x0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_robo_section, {
        backColor: "rgb(16, 202, 249)",
        textColor: "#ffffff",
        offset: "x1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_robo_section, { offset: "x05" }, {
            default: _withCtx(() => [
              _createVNode(_component_robo_text, {
                weight: "bold",
                inline: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_robo_text, {
                weight: "normal-italic",
                inline: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createVNode(_component_robo_link, { href: "https://wiki.robonomics.network/docs/home-assistant-begin/" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_robo_section, { offset: "x05" }, {
            default: _withCtx(() => [
              _createVNode(_component_robo_text, {
                weight: "bold",
                inline: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_robo_text, {
                weight: "normal-italic",
                inline: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_robo_section, { offset: "x05" }, {
            default: _withCtx(() => [
              _createVNode(_component_robo_text, {
                weight: "bold",
                inline: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_robo_text, {
                weight: "normal-italic",
                inline: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}